import { API } from "../Client";
import { Category } from "./types";

namespace CategoryService {
    export async function getCategories(): Promise<Category[]> {
        const res= await API.get('/stock-assets/data/categories');
        return res?.data || [];
    }

    export async function getCategory(id: string, includeLatestQuote = false): Promise<Category> {
        const res = await API.get(`/stock-assets/data/categories/${id}`, {
            params: {
                includeLatestQuote,
            }
        });
        return res?.data;
    }
}

export default CategoryService;
